const formatDate = (date) => {
  const d = new Date(date);
  let month = `${d.getMonth() + 1}`;
  let day = `${d.getDate()}`;
  const year = d.getFullYear();

  if (month.length < 2) month = `0${month}`;
  if (day.length < 2) day = `0${day}`;

  return [year, month, day].join('-');
};

const reportExportFileName = (rptName) => `${formatDate(new Date())} - ${rptName}`;

// eslint-disable-next-line import/prefer-default-export
export {
  formatDate,
  reportExportFileName,
};
